module.exports = __webpack_public_path__ + "media/add-ons/expo@3x-6a3841b8.png";